var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecordIncident(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#604596",
    fillOpacity: 0.88
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 35.5C31 35.7652 30.8946 36.0196 30.7071 36.2071C30.5196 36.3946 30.2652 36.5 30 36.5C29.7348 36.5 29.4804 36.3946 29.2929 36.2071C29.1054 36.0196 29 35.7652 29 35.5C29 35.2348 29.1054 34.9804 29.2929 34.7929C29.4804 34.6054 29.7348 34.5 30 34.5C30.2652 34.5 30.5196 34.6054 30.7071 34.7929C30.8946 34.9804 31 35.2348 31 35.5ZM30.75 27.25C30.75 27.0511 30.671 26.8603 30.5303 26.7197C30.3897 26.579 30.1989 26.5 30 26.5C29.8011 26.5 29.6103 26.579 29.4697 26.7197C29.329 26.8603 29.25 27.0511 29.25 27.25V31.75C29.25 31.9489 29.329 32.1397 29.4697 32.2803C29.6103 32.421 29.8011 32.5 30 32.5C30.1989 32.5 30.3897 32.421 30.5303 32.2803C30.671 32.1397 30.75 31.9489 30.75 31.75V27.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.836 21.2448C28.799 19.5798 31.201 19.5798 32.164 21.2448L41.131 36.7488C42.094 38.4158 40.891 40.5008 38.966 40.5008H21.034C19.108 40.5008 17.906 38.4158 18.869 36.7488L27.836 21.2448ZM30.866 21.9958C30.7782 21.8438 30.652 21.7176 30.5 21.6298C30.3479 21.5421 30.1755 21.4959 30 21.4959C29.8244 21.4959 29.652 21.5421 29.5 21.6298C29.348 21.7176 29.2217 21.8438 29.134 21.9958L20.168 37.4998C20.08 37.6519 20.0335 37.8244 20.0334 38.0001C20.0333 38.1758 20.0794 38.3484 20.1672 38.5006C20.255 38.6528 20.3814 38.7791 20.5335 38.8669C20.6857 38.9548 20.8583 39.0009 21.034 39.0008H38.966C39.1415 39.0008 39.3139 38.9546 39.466 38.8669C39.618 38.7791 39.7442 38.6528 39.832 38.5008C39.9197 38.3488 39.966 38.1764 39.9659 38.0008C39.9659 37.8253 39.9197 37.6529 39.832 37.5008L30.866 21.9948V21.9958Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordIncident);
export default __webpack_public_path__ + "static/media/record-incident.6beb01c331b78afab3df05029e40c31f.svg";
export { ForwardRef as ReactComponent };